<template>
  <div class="has-text-centered">
    <div class="app-block  p-md">
      <div>
        <p><strong>Vous souhaitez payer en espèces</strong></p>
        <p>Veuillez vous rendre sur le campus de votre choix pour régler les frais de scolarité de <strong>{{
            totalCheckout
          }} {{ school.fees_currency }}</strong></p>
        <p>Un reçu vous sera remis et une confirmation d'inscription sera envoyée par mail et déposée sur
          Diderot Max</p>
      </div>


      <hr>

      <div class="has-text-centered">
        <transition name="slide-fade">
          <div class="has-text-danger">{{ errorMsg }}</div>
        </transition>
        <button :class="'button button-save ' + isLoading" @click="send">Je règle par espèces</button>
      </div>


    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  data () {
    return {
      isLoading: '',
      errorMsg: ''
    }
  },
  props: {
    school: { type: Object },
    totalCheckout: { type: Number },
    credit: { type: Number },
    discount: { type: Array },
    candidate: { type: Object },
    guarantor: { type: Number }
  },
  computed: {
    ...mapGetters({
      status: 'orders/status',
      statusMessage: 'orders/statusMessage'
    }),
    ...mapGetters(
        'orders', [
          'orderRef',
          'cartChoices',
          'selectedOrder'
        ]
    ),
    application () {
      return this.candidate.applications
    },
  },
  methods: {
    ...mapActions(
        'orders', [
          'orderCheckout'
        ]
    ),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    send: function () {
      this.toggleLoading()
      const order = {}
      order.id = this.selectedOrder ? this.selectedOrder.id : this.orderRef
      order.cart = this.cartChoices
      order.guarantor = this.guarantor
      order.order_date = new Date()
      order.payment_mode = 'BANK-NOTE'
      order.credit = this.credit
      order.discount = this.discount
      order.payment_total = this.totalCheckout
      order.payment_currency = this.school.fees_currency
      order.payment_number = 1
      order.school = this.$route.params.school
      order.payments = [{
        'date': new Date(),
        'amount': this.totalCheckout,
        'number': 1
      }]
      this.orderCheckout(order).then((result) => {
        if (this.status === 200) {
          this.toggleLoading()
          this.$emit('send')
        } else if (this.status === 403) {
          this.toggleLoading()
          this.$emit('notAuthenticated')
        } else {
          this.toggleLoading()
          if (this.statusMessage) {
            this.errorMsg = this.statusMessage
          }else{
            this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
          }
        }
      }).catch(() => {
        this.toggleLoading()
        if (this.statusMessage) {
          this.errorMsg = this.statusMessage
        }else{
          this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
        }
      })
    }
  }
}
</script>
